import React, { useContext } from 'react';

import { LabelsProvider } from './LabelsContext';
import { ThemeProvider, useTheme } from './ThemeContext';

const ContestContext = React.createContext<Contest>(null);

export function useContest(): Contest {
    return useContext(ContestContext);
}

export { useTheme };

interface ContestProviderProps {
    children: React.ReactNode;
    contest: Contest;
}

export function ContestProvider({ children, contest }: ContestProviderProps) {
    const { theme = null, labels = {} } = contest || {};

    return (
        <ContestContext.Provider value={contest}>
            <LabelsProvider labels={labels}>
                <ThemeProvider theme={theme}>{children}</ThemeProvider>
            </LabelsProvider>
        </ContestContext.Provider>
    );
}

export default ContestContext;
